import {
  DoctorGetDocumentsDocument,
  DoctorMSMedicalRecordEntity,
  useDoctorCreateDocumentMutation,
} from "lib/graphql/megaSchema";
import { Maybe } from "lib/types";
import { MedicalDocumentationDropzone } from "./MedicalDocumentationDropzone";
import { MedicalDocumentationTable } from "./Table";

type Props = {
  title?: string;
  patientId: Maybe<string>;
  documents: DoctorMSMedicalRecordEntity[];
  withUpload?: boolean;
  isDisplayOnly?: boolean;
};

export const MedicalDocumentationList = ({
  title,
  withUpload,
  patientId,
  documents,
  isDisplayOnly = false,
}: Props) => {
  useDoctorCreateDocumentMutation({
    refetchQueries: [DoctorGetDocumentsDocument],
    awaitRefetchQueries: true,
  });

  return (
    <div
      className={`flex flex-col ${title && "p-4"} gap-4 rounded-lg bg-white`}
    >
      {title && (
        <div className="flex justify-between align-middle">
          <span className="font-paragraph-1 text-jutro-new-warm-gray-800">
            {title}
          </span>
        </div>
      )}

      <MedicalDocumentationTable
        data={documents}
        withRowActions={Boolean(title)}
        isDisplayOnly={isDisplayOnly}
      />

      {withUpload && <MedicalDocumentationDropzone patientId={patientId} />}
    </div>
  );
};
